import React from "react";
import "../styles/components/footer.css";
import logo from "../media/logo.png";
import { Link } from "react-router-dom";
import { MDBIcon } from 'mdb-react-ui-kit';

const Footer = () => {
  return (
    <>
      <div className="footer-container">
        <div className="row1">
          <Link to="/">
          <img src={logo} alt="" className="footer-logo" /></Link>
        </div>
        <div className="row2">
          <div className="row2-col">
            <h3 className="row2-col-head">
            Hagámoslo juntos</h3>
            <ul className="row2-col-list">
              <Link to="/eater-cheffy">
                <li className="row2-col-list-itme">
                Convertirte en Eater en Cheffy
                </li>
              </Link>

              <Link to="/cooker-cheffy">
                {" "}
                <li className="row2-col-list-itme">
                Convertirte en Cooker en Cheffy
                </li>
              </Link>

              <Link to="/security">
                {" "}
                <li className="row2-col-list-itme">Seguridad</li>
              </Link>

              <Link to="/join-us">
                <li className="row2-col-list-itme">Trabaja Con Nosotros</li>
              </Link>
            </ul>
          </div>
          <div className="row2-col">
            <h3 className="row2-col-head">Enlaces de interés</h3>
            <ul className="row2-col-list">
              <Link to="/about-us">
                <li className="row2-col-list-itme">Sobre nosotros</li>
              </Link>
              <Link to="/faqs">
                <li className="row2-col-list-itme">Preguntas frecuentes</li>
              </Link>

              <Link to="/privacy-policy">
                <li className="row2-col-list-itme">Política de privacidad</li>
              </Link>
            </ul>
          </div>
          <div className="row2-col">
            <ul className="row2-col-list">
              <li className="row2-col-list-itme">
                <img
                  src="https://glovoapp.com/images/app_store/download-button-new.svg"
                  alt=""
                  className="list-item-img"
                />
              </li>
              <li className="row2-col-list-itme">
                <img
                  src="https://glovoapp.com/images/google_play/download-button-new.svg"
                  alt=""
                  className="list-item-img"
                />
              </li>
             <div className="social-icons-box">
             <li className="row2-col-list-itme">
                <a href="https://www.instagram.com/cheffy_eu/" target="_blank" rel="noopener noreferrer">
                  <MDBIcon fab icon="instagram" size="2x" className="social-icon" />
                </a>
              </li>
              <li className="row2-col-list-itme">
                <a href="https://www.linkedin.com/company/cheffy/about/?viewAsMember=true" target="_blank" rel="noopener noreferrer">
                <MDBIcon fab icon="linkedin-in" size="2x" className="social-icon"/>
                </a>
              </li>
             </div>
            </ul>
          </div>
        </div>

        <div class="custom-shape-divider-top-1733557588">
          <svg
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
          >
            <path
              d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
              class="shape-fill"
            ></path>
          </svg>
        </div>
      </div>
    </>
  );
};

export default Footer;
